module.exports = __webpack_public_path__ + "static/media/redo-icon.361c65e1.svg";